/**
 * GLOW 푸터: 상단 메가메뉴(MegaMenu)와 동일한 규칙으로 2depth 링크를 구성합니다.
 */

/** MegaMenu.jsx와 동일한 자식 항목 URL 결정 */
export function resolveFooterMenuItemUrl(child) {
  if (!child) return null;
  const firstChild = child.children?.length ? child.children[0] : null;
  const firstChildHref = firstChild?.href && firstChild.href !== '#' ? firstChild.href : null;
  const childHref = child.href && child.href !== '#' ? child.href : '#';
  const targetUrl =
    (!childHref || childHref === '#') && firstChildHref
      ? firstChildHref
      : childHref && childHref !== '#'
        ? childHref
        : null;
  return targetUrl;
}

export function isExternalFooterHref(href) {
  return Boolean(href && /^(https?:)?\/\//.test(href));
}

/**
 * @param {Array<{ label?: string, href?: string, children?: Array }>} menuData
 * @returns {Array<{ title: string, iconType: string, items: Array<{ text: string, link: string }> }>}
 */
export function buildGlowFooterSectionsFromMenu(menuData) {
  if (!Array.isArray(menuData) || menuData.length === 0) return [];
  const sections = [];
  for (const top of menuData) {
    if (!top.children?.length) continue;
    const items = [];
    for (const child of top.children) {
      const link = resolveFooterMenuItemUrl(child);
      if (link) items.push({ text: child.label || '', link });
    }
    if (items.length > 0) {
      sections.push({
        title: top.label || '',
        iconType: 'arrow',
        items
      });
    }
  }
  return sections;
}

function normFooterSectionTitle(t) {
  return String(t || '')
    .replace(/\s+/g, ' ')
    .trim();
}

/** 1depth 제목이「GLOW 소개」/ About GLOW 계열인지 */
function isGlowIntroSectionTitle(title) {
  const compact = normFooterSectionTitle(title).replace(/\s/g, '');
  if (compact === 'GLOW소개') return true;
  const n = normFooterSectionTitle(title);
  if (/about\s+glow/i.test(n)) return true;
  return /GLOW/i.test(n) && (n.includes('소개') || /about/i.test(n));
}

/** 1depth 제목이「알림 & 지원」/ Notifications & Support 계열인지 */
function isNoticeSupportSectionTitle(title) {
  const n = normFooterSectionTitle(title);
  if (n === '알림 & 지원' || n.replace(/\s/g, '') === '알림&지원') return true;
  if (/notification/i.test(n) && /support/i.test(n)) return true;
  return n.includes('알림') && n.includes('지원');
}

/**
 * 푸터에는 상단 메뉴 중「GLOW 소개」~「알림 & 지원」1depth 구간만 노출합니다.
 * @param {Array<{ title?: string }>} sections - buildGlowFooterSectionsFromMenu 결과
 */
export function sliceGlowFooterSectionsByMenuRange(sections) {
  if (!Array.isArray(sections) || sections.length === 0) return [];
  const startIdx = sections.findIndex((s) => isGlowIntroSectionTitle(s.title));
  const endIdx = sections.findIndex((s) => isNoticeSupportSectionTitle(s.title));
  if (startIdx === -1 || endIdx === -1 || endIdx < startIdx) return [];
  return sections.slice(startIdx, endIdx + 1);
}
